import { CSSZSickLeaveCertificate } from '../Interfaces/CSSZ.interface';
import { getMomentDate } from '../../../Utils/dates.util';

export type SickLeaveYearHeaderRow = {
	rowType: 'yearHeader';
	id: string;
	year: number;
	count: number;
	isOpen: boolean;
};

export type SickLeaveCertificateRow = {
	rowType: 'certificate';
	id: string;
	sickLeave: CSSZSickLeaveCertificate;
};

export type SickLeaveListRow = SickLeaveYearHeaderRow | SickLeaveCertificateRow;

export function buildSickLeaveYearRows(params: {
	flatData: CSSZSickLeaveCertificate[];
	openYears: Record<number, boolean>;
	currentYear: number;
}): SickLeaveListRow[] {
	const { flatData, openYears, currentYear } = params;

	const groups = new Map<number, CSSZSickLeaveCertificate[]>();
	for (const sickLeave of flatData) {
		const year = getMomentDate(sickLeave.createdAt).year();
		const list = groups.get(year);
		if (list) list.push(sickLeave);
		else groups.set(year, [sickLeave]);
	}

	const years = Array.from(groups.keys());

	const result: SickLeaveListRow[] = [];
	for (const year of years) {
		const sickLeaves = groups.get(year) ?? [];
		const isOpen = openYears[year] ?? year === currentYear;

		result.push({
			rowType: 'yearHeader',
			id: `year-${year}`,
			year,
			count: sickLeaves.length,
			isOpen,
		});

		if (isOpen) {
			for (const sickLeave of sickLeaves) {
				result.push({
					rowType: 'certificate',
					id: sickLeave.id,
					sickLeave,
				});
			}
		}
	}

	return result;
}
